module.exports = __webpack_public_path__ + "img/boat1.d8f6be2a.png";